@if (!spanMode) {
    <p [ngStyle]="style">
        <ng-container *ngTemplateOutlet="content" />
    </p>
}

@if (spanMode) {
    <span [ngStyle]="style">
        <ng-container *ngTemplateOutlet="content" />
    </span>
}

<ng-template #content>
    <ng-content />
</ng-template>
